import { useField, useFormikContext } from "formik";
import React from "react";
import styled from "styled-components";
import Button from "../Button";
import FieldLabel from "./FieldLabel";
import FieldWrapper from "./FieldWrapper";
import FileUploadField, { FileUploadFieldProps } from "./FileUploadField";

const ImageUploadField = (props: ImageUploadFieldProps) => {
  const { setFieldValue } = useFormikContext();
  const { avatar, ...otherProps } = props;

  const [field] = useField(props);

  if (field.value) {
    return (
      <FieldWrapper>
        <FieldLabel>{props.label}</FieldLabel>
        <DisplayImage
          avatar={avatar}
          src={field.value.data}
          alt={props.label}
        />
        <Button secondary onClick={() => setFieldValue(props.name, null)}>
          Change
        </Button>
      </FieldWrapper>
    );
  }

  return <FileUploadField {...otherProps} accept=".png,.jpg,.jpeg,.webp" />;
};

const DisplayImage = styled.img<{ avatar: boolean }>`
  max-height: 300px;
  margin-bottom: 1rem;
  display: block;

  ${({ avatar }) => {
    if (avatar) {
      return `
        height: 150px;
        width: 150px;
        border-radius: 50%;
      `;
    }
  }}
`;

interface ImageUploadFieldProps extends Omit<FileUploadFieldProps, "accept"> {
  avatar?: boolean;
}

export default ImageUploadField;
